
import React from "react";
import classnames from "classnames";
import styled from 'styled-components'
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";

import {Link} from 'react-router-dom'

import logo from '../../assets/img/qora.png'
import RU from '../../assets/img/flags/RU.png';
import US from '../../assets/img/flags/US.png';

import { useTranslation } from 'react-i18next';
const LogoStyled = styled.img`
  width: 170px;
  height: 50px;
`
const StyledButton = styled.button`
  margin-top: 20px;
  border: none;
  height: 30px;
  outline: none;
  background: transparent;
  font-weight: 600;
  opacity: .8;
  text-transform: uppercase;
  font-size: 12px;
`

function IndexNavbar() {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [navbarCollapse, setNavbarCollapse] = React.useState(false);

  const toggleNavbarCollapse = () => {
    setNavbarCollapse(!navbarCollapse);
    document.documentElement.classList.toggle("nav-open");
  };

  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 299 ||
        document.body.scrollTop > 299
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 300 ||
        document.body.scrollTop < 300
      ) {
        setNavbarColor("navbar-transparent");
      }
    };

    window.addEventListener("scroll", updateNavbarColor);

    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });

  const { t, i18n } = useTranslation();
  function handleClick(lang){
    i18n.changeLanguage(lang);
  }
  return (
    <Navbar className={classnames("fixed-top", navbarColor)} expand="lg">
      <Container>
        <div className="navbar-translate">
          <NavbarBrand
            data-placement="bottom"
            title="Coded by Creative Tim"
          >
            <Link to="/">
              <LogoStyled src={logo} alt='Logo'/>
            </Link>
          </NavbarBrand>
          <button
            aria-expanded={navbarCollapse}
            className={classnames("navbar-toggler navbar-toggler", {
              toggled: navbarCollapse
            })}
            onClick={toggleNavbarCollapse}
          >
            <span className="navbar-toggler-bar bar1" />
            <span className="navbar-toggler-bar bar2" />
            <span className="navbar-toggler-bar bar3" />
          </button>
        </div>
        <Collapse
          className="justify-content-end"
          navbar
          isOpen={navbarCollapse}
        >
          <Nav navbar>
            <NavItem>
                <Link
                  to="/profile-page"
                >
              <NavLink style={{color: 'black'}}>
                  <i className="nc-icon nc-paper" />{t('About')}
              </NavLink>
                </Link>
            </NavItem>
            <NavItem>
                <Link to="/services">
                  <NavLink style={{color: 'black'}}>
                      <i className="nc-icon nc-settings" /> {t('Services')}
                  </NavLink>
                </Link>
            </NavItem>
            <NavItem>
              <UncontrolledDropdown nav inNavbar>
                      <DropdownToggle
                        aria-expanded={false}
                        aria-haspopup={true}
                        caret
                        color="default"
                        data-toggle="dropdown"
                        href="#pablo"
                        id="dropdownMenuButton"
                        nav
                        onClick={e => e.preventDefault()}
                        role="button"
                        style={{color: 'black'}}
                      >
                        <i className="nc-icon nc-delivery-fast" /> {t('UsefulInformation')}
                      </DropdownToggle>
                      <DropdownMenu aria-labelledby="dropdownMenuButton" className="dropdown-info">
                        <DropdownItem onClick={e => e.preventDefault()}>
                          <Link to="/trucks" style={{color: 'black'}}>
                              <i className="nc-icon nc-delivery-fast" /> {t('Trucks')}
                          </Link>
                        </DropdownItem>
                        <DropdownItem onClick={e => e.preventDefault()}>
                          <Link to="/containers" style={{color: 'black'}}>
                            <i className="nc-icon nc-bullet-list-67" /> {t('Containers')}
                          </Link>
                        </DropdownItem>
                        <DropdownItem onClick={e => e.preventDefault()}>
                          <Link to="/water-truck" style={{color: 'black'}}>
                            <i className="nc-icon nc-bullet-list-67" /> {t('SeaTransports')} 
                          </Link>
                        </DropdownItem>
                        <DropdownItem onClick={e => e.preventDefault()}>
                          <Link to="/train" style={{color: 'black'}}>
                            <i className="nc-icon nc-bullet-list-67" /> {t('Wagons')}
                          </Link>
                        </DropdownItem>
                      </DropdownMenu>
              </UncontrolledDropdown>
            </NavItem>
            <NavItem>
                <Link to="/our-projects">
                  <NavLink style={{color: 'black'}}>
                      <i className="nc-icon nc-briefcase-24" /> {t('OurWorks')}
                  </NavLink>
                </Link>
            </NavItem>
            {/* <NavItem>
            <UncontrolledDropdown nav inNavbar>
                      <DropdownToggle
                        aria-expanded={false}
                        aria-haspopup={true}
                        data-toggle="dropdown"
                        id="dropdownMenuButton"
                        nav
                        onClick={e => e.preventDefault()}
                        style={{color: 'black'}}
                      >
                        <img src={RU} alt="flag" /> Русский
                      </DropdownToggle>
                      <DropdownMenu aria-labelledby="dropdownMenuButton" className="dropdown-info">
                        <DropdownItem onClick={e => e.preventDefault()}>
                          <Link to="/" style={{color: 'black'}}>
                            <img src={US} alt="flag" /> English
                          </Link>
                        </DropdownItem>
                      </DropdownMenu>
              </UncontrolledDropdown>
            </NavItem> */}
            <NavItem>
                <StyledButton onClick={()=>handleClick('ru')}><img src={RU} alt="flag" /> Русский</StyledButton>
                <StyledButton onClick={()=>handleClick('en')}><img src={US} alt="flag" /> English</StyledButton>
            </NavItem>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

export default IndexNavbar;
